// extracted by mini-css-extract-plugin
module.exports = {"weight":"ReviewYourBelongingsPanel_weight__DMTEL","overage":"ReviewYourBelongingsPanel_overage__q9Yfr","estimation":"ReviewYourBelongingsPanel_estimation__XqvNY"};